import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AttendanceSheetVM } from "@shared-kernel/application/ports/student/student-repository";

export const studentRetrieveAllAttendanceSheets = createAsyncThunk<AttendanceSheetVM[], void, { extra: Partial<Dependencies> }>(
  "attendanceSheets/studentRetrieveAllAttendanceSheets",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getAllAttendanceSheets();
  },
);
